import devto from "../../assets/img/community/devto.webp";
import github from "../../assets/img/community/github.webp";
import stackoverflow from "../../assets/img/community/stackoverflow.webp";
import stackexchange from "../../assets/img/community/stackexchange.webp";
import medium from "../../assets/img/community/medium.webp";
import reddit from "../../assets/img/community/reddit.webp";
import coderwall from "../../assets/img/community/coderwall.webp";
import bytes from "../../assets/img/community/bytes.webp";
import geek from "../../assets/img/community/geek.webp";

export const DataCommunity = [
  {
    title: "Dev.to",
    path: "https://dev.to/",
    cName: "icon",
    icon: devto,
    description:
      "I love this website, for me it's the best community for a dev, you can write and read a very good article, you will for sure learn new things which concern the world of programming.",
  },
  {
    title: "Stack Overflow",
    path: "https://stackoverflow.com/-channel",
    cName: "icon",
    icon: stackoverflow,
    description:
      "Stack Overflow is an open community for anyone that codes. We help you get answers to your toughest coding questions, share knowledge with your coworkers in private, and find your next dream job.",
  },
  {
    title: "Stack Exchange",
    path: "https://stackexchange.com/",
    cName: "icon",
    icon: stackexchange,
    description:
      "Each of our 176 communities is built by people passionate about a focused topic. Experts like you can vote on posts, so the most helpful answers are easy to find. Earn reputation and additional privileges for posts others find helpful.",
  },
  {
    title: "Medium",
    path: "https://medium.com/topic/programming",
    cName: "icon",
    icon: medium,
    description:
      "Dive deeper on topics that matter to you. Select what you're into. We'll help you find great things to read.",
  },
  {
    title: "Github",
    path: "https://github.com/",
    cName: "icon",
    icon: github,
    description:
      "GitHub is a development platform inspired by the way you work. From open source to business, you can host and review code, manage projects, and build software alongside 50 million developers",
  },
  {
    title: "Reddit",
    path: "https://www.reddit.com/r/webdev/",
    cName: "icon",
    icon: reddit,
    description: "Choose the right topic and discover what people says.",
  },
  {
    title: "Coderwall",
    path: "https://coderwall.com/",
    cName: "icon",
    icon: coderwall,
    description:
      "Learn & Share Something New. The latest development and design tips, tools, and projects from our developer community.",
  },
  {
    title: "GeeksfoGeeks",
    path: "https://www.geeksforgeeks.org/",
    cName: "icon",
    icon: geek,
    description:
      "How many times were you frustrated while looking out for a good collection of programming/algorithm/interview questions? What did you expect and what did you get? This portal has been created to provide well written, well thought and well explained solutions for selected questions.",
  },
  {
    title: "Bytes",
    path: "https://bytes.com/",
    cName: "icon",
    icon: bytes,
    description:
      "A community for Developers and IT Professionals. Covering topics such as: Software Development, Web Development, Database Development + Optimization, Database Administration, System Administration, Network Administration and much more.",
  },
];
